// Who may open the Invoicing and Quotation pages.
//
// Single source of truth for the gate rendered in three places: the Sidebar links,
// InvoicingPage and QuotationPage. The rule itself (which teamspaces, which roles) lives ONLY on the
// server (`web_app/gva_security/policy.py`, capability `invoicing.read`), which `/users/me/` hands to
// the app as `role_dict[<teamspace name>].invoicing`; nothing here re-derives it.

// Developer in ANY teamspace, not just the selected one — the server's IsDeveloper permission is
// likewise any-teamspace, so a Developer can open the page of a teamspace they hold no row in.
const isDeveloperAnywhere = (user, roleDict) =>
  !!user && Object.values(roleDict || {}).some((entry) => entry?.role?.includes('Developer'));

// `teamspaceName` is the name of the currently selected teamspace.
const canAccessInvoicing = (user, roleDict, teamspaceName) =>
  isDeveloperAnywhere(user, roleDict) || roleDict?.[teamspaceName]?.invoicing === true;

export { isDeveloperAnywhere, canAccessInvoicing };
